
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M235.3 22.1C158.7 28.9 90.5 72.3 52.5 138.4c-14.8 25.8-24.7 55.2-29.1 86.1-2.1 14.4-2.3 44.6-.5 58.5 5.6 43.9 20.7 81.3 46.8 115.8l8.5 11.2-5.7 9c-8.4 13.4-9.9 17.6-9.9 29 0 7.5.5 10.7 2.3 15.3 4.5 11.4 15.2 21.5 26.8 25.3 5.5 1.8 10 1.9 92.3 1.9 91.9 0 92.9 0 117.8-5.1 58.8-11.8 113.4-48.4 148.1-99.4 28.9-42.4 43.9-96.4 40.2-145-3.6-47.5-19.1-89.1-46.8-126.2-9.7-13-32.9-36.3-45.3-45.6-48-35.8-104.9-52.3-162.7-47.1M278 65.5c83.4 9.9 150.4 71.8 166.4 154 5.2 26.8 4.6 52.6-1.8 79.1-3.5 14.4-7 24.2-13.7 38.2-25.9 54.7-77.6 95.3-136.4 107.1-19.2 3.9-29 4.2-109.7 3.9l-77.7-.3 5.8-9.5c8.3-13.8 9.6-17.7 9.5-29-.1-12.2-2.2-17.7-11.1-29-21.2-26.8-34-52.9-40.7-83.1-14.8-67.3 7.8-138.4 58.3-183.6C168.4 76.2 223 59 278 65.5"}}),_c('path',{attrs:{"d":"M243.9 133.8c-15.8 8.3-19.3 29.6-6.8 42 5.7 5.7 10.4 7.7 18.9 7.7 5.7 0 8.4-.5 11.6-2.2 11.6-6.2 17.4-18.9 14-30.7C278 138.5 268.3 131 256 131c-5.5 0-7.8.5-12.1 2.8M226 212.6c-17.6 7.8-16.1 34.5 2.3 39.5 2.3.6 4.8 1.3 5.5 1.5.9.3 1.2 10.2 1.2 45.4 0 42.4.1 45.3 1.9 48.8 1.1 2 3.2 4.9 4.8 6.4 5.2 4.9 8.9 5.8 25.1 5.8 14 0 15.1-.1 20.1-2.6 12.7-6.4 15.5-21.9 5.9-32.9-3.2-3.7-5.2-4.9-9.9-6.2l-5.8-1.6-.3-46.2-.3-46.1-2.5-3.7c-1.4-2.1-4.3-5-6.4-6.5-3.9-2.7-4.2-2.7-21-2.9-13.7-.2-17.8 0-20.6 1.3"}})])
          )
        }
      }
    